import {GET_LOCATION_FAILURE, GET_LOCATION_REQUEST, GET_LOCATION_SUCCESS} from 'new-constants/geolocation.constants';

export const getLocationRequest = () => ({
	type: GET_LOCATION_REQUEST,
});

export const getLocationSuccess = (latitude, longitude, timestamp) => ({
	type: GET_LOCATION_SUCCESS,
	latitude,
	longitude,
	timestamp,
});

export const getLocationFailure = () => ({
	type: GET_LOCATION_FAILURE,
});
